export default __webpack_public_path__ + "static/media/olva3.14ea51c8.jpg";